export default __webpack_public_path__ + "images/dollar-sign-solid-blue.bd937f7574344b13c43fe07c0a75aad7.png";